$('.catalog').on('click', '.category-selector', function(e) {
	e.preventDefault();

	var parent_id = $(this).data('id');

	let locale = $('html').attr('lang');


    if ($(this).hasClass('open')) {
        $('#catalog-category-'+parent_id).slideUp(200);
        $('#catalog-category-'+parent_id+' .catalog-wrapper').remove();
        $(this).removeClass('open');
        

    } else {

        $(this).addClass('open');

        $.ajax({
            url: '/'+locale+"/api/v1/ajax/getCategories",
            type: "POST",
            cache: false,
            data:{parent:parent_id},

            beforeSend: function() {
                $('#catalog-category-'+parent_id).slideUp(200);
                $('#catalog-category-'+parent_id+' .catalog-wrapper').remove();
            },
            success: function(response){
                $('#catalog-category-'+parent_id).append(response);
            },
            complete: function() {
                $('#catalog-category-'+parent_id).slideDown(200);

                
            }
        });  
    }

    

	return false;
});

$('.catalog').on('click', '.xhr__product', function(e) {
    e.preventDefault();

    $('.xhr__product').removeClass('active');
    $(this).addClass('active');

    var product_id = $(this).data('product');

    let locale = $('html').attr('lang');

    $(this).parent('.catalog__product--item').parent('.catalog-list').next('.catalog--product__content').attr('id', 'product__'+product_id);


    $.ajax({
            url: '/'+locale+"/api/v1/ajax/getProduct",
            type: "POST",
            cache: false,
            data:{product_id:product_id},

            beforeSend: function() {
                $('.catalog--product__content .catalog-list').remove();
            },
            success: function(response){
                console.log(response);
                $('#product__'+product_id).append(response);
                
            },
            complete: function() {

                if($(window).width() <= 991) {
                    // $('.wrapper').addClass('no-scroll');
                }
                $('#product__'+product_id).fadeIn();

                $('.catalog__product--description a').attr('target', '_blank');

                
            }
        });  

    return false;
});



$('.catalog').on('click', '.product__close--top', function(e) {
    e.preventDefault();

    if ($(window).width() <= 575) {
        $('html').removeClass('multi_overflow');
    }

    

    $('.catalog--product__content .catalog-list').remove();

    $('.catalog--product__content').fadeOut();
    
    if($(window).width() <= 991) {
        // $('.wrapper').removeClass('no-scroll');
    }

    return false;
});

$('.catalog').on('click', '.catalog__product--images img', function(e) {
    e.preventDefault();

    $('.catalog__product--images .image-item').removeClass('current');
    $(this).parent().addClass('current');

    var img = $(this).attr('src');

    $('.catalog__product--image[data-product-id='+$(this).parent().attr('data-target')+'] img').attr('src', img);

    return false;
});







